import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DetailComponents.css';

const AddClientModal = ({ onSave, onClose }) => {
  const [newClient, setNewClient] = useState({
    email: '',
    password: '',
    name: '',
    midName: '',
    lastName1: '',
    lastName2: '',
    dob: null
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewClient({ ...newClient, [name]: value });
  };

  const handleDateChange = (date) => {
    setNewClient({ ...newClient, dob: date });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!newClient.email || !newClient.password || !newClient.name || !newClient.lastName1 || !newClient.dob) {
      alert('Please fill in all required fields (Email, Password, First Name, Last Name, Date of Birth).');
      return;
    }
    onSave(newClient);
  };

  // Handle ESC key press
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscKey);
    return () => {
      document.removeEventListener('keydown', handleEscKey);
    };
  }, [onClose]);

  // Handle click outside modal
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal">
        <h3>Add New Client</h3>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email *</label>
            <input
              type="email"
              name="email"
              value={newClient.email}
              onChange={handleChange}
              autoComplete="new-email"
              required
            />
          </div>
          <div className="form-group">
            <label>Password *</label>
            <input
              type="text" // Changed from "password" to "text" to show plain text
              name="password"
              value={newClient.password}
              onChange={handleChange}
              autoComplete="new-password"
              required // Made password field required
            />
          </div>
          <div className="form-group">
            <label>First Name *</label>
            <input
              type="text"
              name="name"
              value={newClient.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Middle Name</label>
            <input
              type="text"
              name="midName"
              value={newClient.midName}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Last Name *</label>
            <input
              type="text"
              name="lastName1"
              value={newClient.lastName1}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group">
            <label>Last Name 2</label>
            <input
              type="text"
              name="lastName2"
              value={newClient.lastName2}
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>Date of Birth *</label>
            <DatePicker
              selected={newClient.dob}
              onChange={handleDateChange}
              dateFormat="MM/dd/yyyy"
              showMonthDropdown
              showYearDropdown
              dropdownMode="select"
              required
            />
          </div>
          <div className="modal-actions">
            <button type="button" className="modal-action-button" onClick={onClose}>Cancel</button>
            <button type="submit" className="modal-action-button">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddClientModal;